import React from "react";
import { Animated, Text } from "react-native"
import { useCssStyle } from "../../customHook/getCssStyle";
import { useEffect, useRef } from "react";



export const Chip = ({ text, startPulsating, style }) => {

    const getStyles = useCssStyle();

    const textOpacity = useRef(new Animated.Value(1)).current;

    let pulsingAnimation = null;
    const startPulsing = () => {
        pulsingAnimation = Animated.loop(
            Animated.sequence([
                Animated.timing(textOpacity, {
                    toValue: 0.5,
                    duration: 800,
                    useNativeDriver: true,
                }),
                Animated.timing(textOpacity, {
                    toValue: 1,
                    duration: 800,
                    useNativeDriver: true,
                }),
            ])
        ).start();
    }

    const stopPulsing = () => {
        if (pulsingAnimation) {
            pulsingAnimation.stop();
            textOpacity.setValue(1); // reset so it’s not left half-faded
        }
    };

    useEffect(() => {
        if (startPulsating) {
            startPulsing();
        } else {
            stopPulsing();
        }

        return () => {
            stopPulsing();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startPulsating])


    return (
        <Animated.View style={getStyles(['chipContainer', style, { opacity: textOpacity }])} id='chipContainer'>
            <Text style={getStyles(['chipContainerText'])} id='chipContainerText' >{text}</Text>
        </Animated.View>
    )
}